import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import useSocket from "../../../hooks/useSocket";
import GalaxyLayout from "../../client/components/layout/GalaxyLayout";
import "../../../assets/galaxy/RangBaz.css";
import axiosInstance from "../../../utils/axiosInstance";
import { setUserData } from "../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";

export default function Lucky7Galaxy() {
  const [chipActive, setChipActive] = useState(100);
  const [gameRoundId, setGameRoundId] = useState("");
  const [array_list, set_array_list] = useState([]);
  const [betList, setBetList] = useState([]);
  const [resultList, setResultList] = useState([]);
  const dispatch = useDispatch();

  const [sevenDownWin, setSevenDownWin] = useState(false);
  const [sevenWin, setSevenWin] = useState(false);
  const [sevenUpWin, setSevenUpWin] = useState(false);

  const [evenWin, setEvenWin] = useState(false);
  const [oddWin, setOddWin] = useState(false);

  const [redWin, setRedWin] = useState(false);
  const [blackWin, setBlackWin] = useState(false);

  const [spadeWin, setSpadeWin] = useState(false);
  const [heartWin, setHeartWin] = useState(false);
  const [clubWin, setClubWin] = useState(false);
  const [diamondWin, setDiamondWin] = useState(false);

  const [a23Win, setA23Win] = useState(false);
  const [card456Win, setCard456Win] = useState(false);
  const [card8910Win, setCard8910Win] = useState(false);
  const [jqkWin, setJqkWin] = useState(false);

  const [card1Win, setCard1Win] = useState(false);
  const [card2Win, setCard2Win] = useState(false);
  const [card3Win, setCard3Win] = useState(false);
  const [card4Win, setCard4Win] = useState(false);
  const [card5Win, setCard5Win] = useState(false);
  const [card6Win, setCard6Win] = useState(false);
  const [card7Win, setCard7Win] = useState(false);
  const [card8Win, setCard8Win] = useState(false);
  const [card9Win, setCard9Win] = useState(false);
  const [card10Win, setCard10Win] = useState(false);
  const [card11Win, setCard11Win] = useState(false);
  const [card12Win, setCard12Win] = useState(false);
  const [card13Win, setCard13Win] = useState(false);

  let isCallSend = false;
  let card1 = 1;
  let card2 = 1;
  let card3 = 1;


  let sevenDownOdd = 0;
  let sevenOdd = 0;
  let sevenUpOdd = 0;
  let evenOdd = 0;
  let oddOdd = 0;
  let redOdd = 0;
  let blackOdd = 0;
  let suitOdd = 0;

  let hhOdd = 0;
  let ddOdd = 0;
  let ccOdd = 0;
  let ssOdd = 0;
  let singleCardOdd = 0;
  let card3Odd = 0;

  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "galaxy",
    type: "lucky7_galaxy"
  });
  console.log("Socket data:", data);
  const payloadResult = data?.data?.result;
  const updateUserData = async (userData) => {
    await dispatch(setUserData(userData));
  };

  const getBetList = async () => {
    if (roundId !== "") {
      try {
        let betObj = {};
        betObj.catmid = roundId;
        betObj.game_name = "lucky7galaxy_virtual";
        const response = await axiosInstance.post(
          "/casino/get-casino-bet-list",
          betObj
        );

        setBetList(response.data);
        console.log("betList->", response.data);
      } catch (error) {}
    }
  };

  const placeBet = async () => {
    let totalAmount = 0;
    if (array_list != "" && array_list.length > 0) {
      for (let j = 0; j < array_list.length; j++) {
        let obj = array_list[j];
        totalAmount = totalAmount + obj.amount;
      }
    }
    //console.log("totalAmount->", totalAmount);
    //console.log("placeBet->", array_list);

    try {
      let betObj = {};
      betObj.game_name = "lucky7galaxy_virtual";
      betObj.catmid = roundId;
      betObj.betPlaceArr = array_list;
      betObj.game_type = 10;
      set_array_list([]);

      const response = await axiosInstance.post(
        "/casino/place-bet-casino-multiple",
        betObj
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data?.status !== undefined &&
        response.data?.status !== null
      ) {
        getBetList();
        fetchUserData();
      }
    } catch (error) {
      if (error.response?.data !== undefined && error.response?.data !== null) {
        debugger;
      }
    }

    set_array_list([]);
  };

  let eventStatus = "";
  let roundId = "";
  let timeLeft = "";

  let suspend1 = "";
  let b1 = 0;
  let betfairOdds = null;
  let resultCard = "";
  let resultCardNo = 0;
  if (
    data !== "" &&
    data != null &&
    data.data !== null &&
    data.data !== undefined &&
    data.data.data != undefined
  ) {
    betfairOdds = data.data.data;

    updateUserData(data?.user);

    roundId = betfairOdds.cat_mid;
    eventStatus = betfairOdds.evt_status;
    timeLeft = betfairOdds.left_time;

    sevenDownOdd = betfairOdds.b1;
    sevenUpOdd = betfairOdds.b2;
    sevenOdd = betfairOdds.b3;
    redOdd = betfairOdds.b4;
    blackOdd = betfairOdds.b5;

    oddOdd = betfairOdds.b6;
    evenOdd = betfairOdds.b7;

    suitOdd = betfairOdds.b8;
    card3Odd = betfairOdds.b12;
    singleCardOdd = betfairOdds.b13;

    if (timeLeft == 1) {
      timeLeft = 0;
    }
    timeLeft = parseInt(timeLeft);
    suspend1 = betfairOdds.suspend1;
    b1 = betfairOdds.b1;
    resultCard = betfairOdds.c1;

    if (timeLeft <= 2) {
      //suspend1 = 1;
    }

    if (betfairOdds.result == 1) {
      card1 = resultCard;
      card2 = 1;
      card3 = 1;
    } else if (betfairOdds.result == 2) {
      card1 = 1;
      card2 = resultCard;
      card3 = 1;
    } else if (betfairOdds.result == 3) {
      card1 = 1;
      card2 = 1;
      card3 = resultCard;
    }

    if (resultCard != "1") {
      let spitCard = resultCard.split("");
      let resultCardVal = spitCard[0];
      if (resultCardVal == "J") {
        resultCardVal = 11;
      }
      if (resultCardVal == "Q") {
        resultCardVal = 12;
      }
      if (resultCardVal == "K") {
        resultCardVal = 13;
      }
      resultCardNo = parseInt(resultCardVal);
    }

    //console.log("array_list->", array_list);

    if (array_list.length > 0 && timeLeft <= 5 && !isCallSend) {
      placeBet();
      isCallSend = true;
    }
  }

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => {
    //setGameRoundId()
    if (gameRoundId == "") {
      setGameRoundId(roundId);
    }
    if (gameRoundId !== roundId) {
      setGameRoundId(roundId);
      resetGame();
    }
    getBetList();
  }, [roundId]);

  const [sevenDown, setSevenDown] = useState(0);
  const [seven, setSeven] = useState(0);
  const [sevenUp, setSevenUp] = useState(0);

  const [evenAmount, setEvenAmount] = useState(0);
  const [oddAmount, setOddAmount] = useState(0);

  const [redAmount, setRedAmount] = useState(0);
  const [blackAmount, setBlackAmount] = useState(0);

  const [hhAmount, setHHAmount] = useState(0);
  const [ddAmount, setDDAmount] = useState(0);
  const [ccAmount, setCCAmount] = useState(0);
  const [ssAmount, setSSAmount] = useState(0);

  const [card1SetAmount, setCard1SetAmount] = useState(0);
  const [card2SetAmount, setCard2SetAmount] = useState(0);
  const [card3SetAmount, setCard3SetAmount] = useState(0);
  const [card4SetAmount, setCard4SetAmount] = useState(0);

  const [card1Amount, setCard1Amount] = useState(0);
  const [card2Amount, setCard2Amount] = useState(0);
  const [card3Amount, setCard3Amount] = useState(0);
  const [card4Amount, setCard4Amount] = useState(0);
  const [card5Amount, setCard5Amount] = useState(0);
  const [card6Amount, setCard6Amount] = useState(0);
  const [card7Amount, setCard7Amount] = useState(0);
  const [card8Amount, setCard8Amount] = useState(0);
  const [card9Amount, setCard9Amount] = useState(0);
  const [card10Amount, setCard10Amount] = useState(0);
  const [card11Amount, setCard11Amount] = useState(0);
  const [card12Amount, setCard12Amount] = useState(0);
  const [card13Amount, setCard13Amount] = useState(0);

  const resetGame = () => {
    setChipActive(100);
    setSevenDown(0);
    setSeven(0);
    setSevenUp(0);
    setEvenAmount(0);
    setOddAmount(0);
    setRedAmount(0);
    setBlackAmount(0);
    setHHAmount(0);
    setDDAmount(0);
    setCCAmount(0);
    setSSAmount(0);

    setCard1SetAmount(0);
    setCard2SetAmount(0);
    setCard3SetAmount(0);
    setCard4SetAmount(0);

    setCard1Amount(0);
    setCard2Amount(0);
    setCard3Amount(0);
    setCard4Amount(0);
    setCard5Amount(0);
    setCard6Amount(0);
    setCard7Amount(0);
    setCard8Amount(0);
    setCard9Amount(0);
    setCard10Amount(0);
    setCard11Amount(0);
    setCard12Amount(0);
    setCard13Amount(0);
    setBetList([]);
  };

  const undo = () => {
    if (array_list !== null && array_list.length > 0) {
      let firstElement = array_list[0];
      let teamname = firstElement.teamname;

      if (teamname == "low card") {
        setSevenDown(0);
      } else if (teamname == "tie card") {
        setSeven(0);
      } else if (teamname == "high card") {
        setSevenUp(0);
      } else if (teamname == "even") {
        setEvenAmount(0);
      } else if (teamname == "odd") {
        setOddAmount(0);
      } else if (teamname == "red") {
        setRedAmount(0);
      } else if (teamname == "black") {
        setBlackAmount(0);
      } else if (teamname == "spade") {
        setHHAmount(0);
      } else if (teamname == "heart") {
        setDDAmount(0);
      } else if (teamname == "club") {
        setCCAmount(0);
      } else if (teamname == "diamond") {
        setSSAmount(0);
      } else if (teamname == "a23") {
        setCard1SetAmount(0);
      } else if (teamname == "456") {
        setCard2SetAmount(0);
      } else if (teamname == "8910") {
        setCard3SetAmount(0);
      } else if (teamname == "jqk") {
        setCard4SetAmount(0);
      } else if (teamname == "card 1") {
        setCard1Amount(0);
      } else if (teamname == "card 2") {
        setCard2Amount(0);
      } else if (teamname == "card 3") {
        setCard3Amount(0);
      } else if (teamname == "card 4") {
        setCard4Amount(0);
      } else if (teamname == "card 5") {
        setCard5Amount(0);
      } else if (teamname == "card 6") {
        setCard6Amount(0);
      } else if (teamname == "card 7") {
        setCard7Amount(0);
      } else if (teamname == "card 8") {
        setCard8Amount(0);
      } else if (teamname == "card 9") {
        setCard9Amount(0);
      } else if (teamname == "card 10") {
        setCard10Amount(0);
      } else if (teamname == "card 11") {
        setCard11Amount(0);
      } else if (teamname == "card 12") {
        setCard12Amount(0);
      } else if (teamname == "card 13") {
        setCard13Amount(0);
      }
      let newArr = array_list.slice(1);
      set_array_list(newArr);
    }
  };

  const initializeBet = (betType, teamname, type, price) => {
    let amt = 0;
    if (teamname == "low card") {
      amt = sevenDown + chipActive;
      setSevenDown(amt);
    } else if (teamname == "tie card") {
      amt = seven + chipActive;
      setSeven(amt);
    } else if (teamname == "high card") {
      amt = sevenUp + chipActive;
      setSevenUp(amt);
    } else if (teamname == "even") {
      amt = evenAmount + chipActive;
      setEvenAmount(amt);
    } else if (teamname == "odd") {
      amt = oddAmount + chipActive;
      setOddAmount(amt);
    } else if (teamname == "red") {
      amt = redAmount + chipActive;
      setRedAmount(amt);
    } else if (teamname == "black") {
      amt = blackAmount + chipActive;
      setBlackAmount(amt);
    } else if (teamname == "spade") {
      amt = hhAmount + chipActive;
      setHHAmount(amt);
    } else if (teamname == "heart") {
      amt = ddAmount + chipActive;
      setDDAmount(amt);
    } else if (teamname == "club") {
      amt = ccAmount + chipActive;
      setCCAmount(amt);
    } else if (teamname == "diamond") {
      amt = ssAmount + chipActive;
      setSSAmount(amt);
    } else if (teamname == "a23") {
      amt = card1SetAmount + chipActive;
      setCard1SetAmount(amt);
    } else if (teamname == "456") {
      amt = card2SetAmount + chipActive;
      setCard2SetAmount(amt);
    } else if (teamname == "8910") {
      amt = card3SetAmount + chipActive;
      setCard3SetAmount(amt);
    } else if (teamname == "jqk") {
      amt = card4SetAmount + chipActive;
      setCard4SetAmount(amt);
    } else if (teamname == "card 1") {
      amt = card1Amount + chipActive;
      setCard1Amount(amt);
    } else if (teamname == "card 2") {
      amt = card2Amount + chipActive;
      setCard2Amount(amt);
    } else if (teamname == "card 3") {
      amt = card3Amount + chipActive;
      setCard3Amount(amt);
    } else if (teamname == "card 4") {
      amt = card4Amount + chipActive;
      setCard4Amount(amt);
    } else if (teamname == "card 5") {
      amt = card5Amount + chipActive;
      setCard5Amount(amt);
    } else if (teamname == "card 6") {
      amt = card6Amount + chipActive;
      setCard6Amount(amt);
    } else if (teamname == "card 7") {
      amt = card7Amount + chipActive;
      setCard7Amount(amt);
    } else if (teamname == "card 8") {
      amt = card8Amount + chipActive;
      setCard8Amount(amt);
    } else if (teamname == "card 9") {
      amt = card9Amount + chipActive;
      setCard9Amount(amt);
    } else if (teamname == "card 10") {
      amt = card10Amount + chipActive;
      setCard10Amount(amt);
    } else if (teamname == "card 11") {
      amt = card11Amount + chipActive;
      setCard11Amount(amt);
    } else if (teamname == "card 12") {
      amt = card12Amount + chipActive;
      setCard12Amount(amt);
    } else if (teamname == "card 13") {
      amt = card13Amount + chipActive;
      setCard13Amount(amt);
    }

    let indexFound = -1;
    let arr = [];
    if (array_list.length > 0) {
      for (let i = 0; i < array_list.length; i++) {
        let obj = array_list[i];
        if (obj.teamname == teamname) {
          indexFound = i;
          break;
        }
      }

      if (indexFound !== -1) {
        const newArr = array_list.filter((_, index) => index !== indexFound);
        //console.log("newArr->", newArr);
        let obj = {};
        obj.market_type = betType;
        obj.teamname = teamname;
        obj.bettype = type;
        obj.odds = price;
        obj.amount = amt;
        obj.catmid = roundId;
        arr = [...newArr, obj];
        set_array_list(arr);
      } else {
        let objNew = {};
        objNew.market_type = betType;
        objNew.teamname = teamname;
        objNew.bettype = type;
        objNew.odds = price;
        objNew.amount = amt;
        objNew.catmid = roundId;
        arr = [...array_list, objNew];
        set_array_list(arr);
      }
    } else {
      let obj = {};
      obj.market_type = betType;
      obj.teamname = teamname;
      obj.bettype = type;
      obj.odds = price;
      obj.amount = amt;
      obj.catmid = roundId;
      arr = [...array_list, obj];
      set_array_list(arr);
    }
  };

  const getDisplayText = (result) => {
    let returnText = "";
    if (result == 1) {
      returnText = "7D";
    } else if (result == 2) {
      returnText = "7U";
    } else if (result == 3) {
      returnText = "7";
    }
    return returnText;
  };

  const fetchUserData = async () => {
    //console.log("Fetching events...");
    try {
      const response = await axiosInstance.get("/user");
      //console.log("user-response->",response);
      if (response.data !== "") {
        await dispatch(setUserData(response.data));
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const getBgColor = (result) => {
    let returnText = "";

    if (result == 1) {
      returnText =
        "linear-gradient(rgb(16, 100, 169), rgb(3, 36, 64)), linear-gradient(rgb(255, 255, 255) 0%, rgba(255, 255, 255, 0))";
    } else if (result == 2) {
      returnText =
        "linear-gradient(rgb(161, 20, 37), rgb(64, 11, 17)), linear-gradient(rgb(255, 255, 255) 0%, rgba(255, 255, 255, 0))";
    } else if (result == 3) {
      returnText =
        "linear-gradient(180deg, #0d8014, #022204 79.82%), linear-gradient(180deg, #fff 0%, hsla(0, 0%, 100%, 0))";
    }
    return returnText;
  };

  const clearWinner = () => {
    setSevenDownWin(false);
    setSevenWin(false);
    setSevenUpWin(false);

    setEvenWin(false);
    setOddWin(false);

    setRedWin(false);
    setBlackWin(false);

    setSpadeWin(false);
    setHeartWin(false);
    setClubWin(false);
    setDiamondWin(false);

    setA23Win(false);
    setCard456Win(false);
    setCard8910Win(false);
    setJqkWin(false);

    setCard1Win(false);
    setCard2Win(false);
    setCard3Win(false);
    setCard4Win(false);
    setCard5Win(false);
    setCard6Win(false);
    setCard7Win(false);
    setCard8Win(false);
    setCard9Win(false);
    setCard10Win(false);
    setCard11Win(false);
    setCard12Win(false);
    setCard13Win(false);
  };

  const getCardValue = (card) => {
    if (!card || card === "1") return 0;

    let value = card.slice(0, -2);

    if (value === "A") return 1;
    if (value === "J") return 11;
    if (value === "Q") return 12;
    if (value === "K") return 13;

    return Number(value);
  };

  const getSuit = (card) => {
    if (!card || card === "1") return "";

    return card.slice(-2);
  };

  useEffect(() => {
    clearWinner();
    if (!data?.data?.data) return;
    const odds = data.data.data;
    if (odds.evt_status !== "CLOSED") return;
    const card = odds.c1;

    if (!card || card === "1" || odds.result === "") return;

    const value = getCardValue(card);
    const suit = getSuit(card);

    console.log("Winner effect", {
      status: odds.evt_status,
      card: odds.c1,
      result: odds.result,
      value,
      suit
    });

    if (odds.result == 1) setSevenDownWin(true);
    if (odds.result == 2) setSevenUpWin(true);
    if (odds.result == 3) setSevenWin(true);

    if (value % 2 === 0) setEvenWin(true);
    else setOddWin(true);

    if (suit === "DD" || suit === "SS") setRedWin(true);
    else setBlackWin(true);

    if (value >= 1 && value <= 3) setA23Win(true);
    else if (value >= 4 && value <= 6) setCard456Win(true);
    else if (value >= 8 && value <= 10) setCard8910Win(true);
    else if (value >= 11 && value <= 13) setJqkWin(true);

    if (suit === "HH") {
      setSpadeWin(true);
    } else if (suit === "DD") {
      setHeartWin(true);
    } else if (suit === "CC") {
      setClubWin(true);
    } else if (suit === "SS") {
      setDiamondWin(true);
    }

    if (value == 1) setCard1Win(true);
    if (value == 2) setCard2Win(true);
    if (value == 3) setCard3Win(true);
    if (value == 4) setCard4Win(true);
    if (value == 5) setCard5Win(true);
    if (value == 6) setCard6Win(true);
    if (value == 7) setCard7Win(true);
    if (value == 8) setCard8Win(true);
    if (value == 9) setCard9Win(true);
    if (value == 10) setCard10Win(true);
    if (value == 11) setCard11Win(true);
    if (value == 12) setCard12Win(true);
    if (value == 13) setCard13Win(true);
  }, [data]);

  return (
    <GalaxyLayout>
      <div
        class="container mt-4"
        id="rbc-app"
        style={{ background: "linear-gradient(180deg, #0D0D0D, #18122B)" }}
      >
        <div>
          <div class="tabs-section">
            <ul class="nav nav-tabs mobile-Tab nav-tabs-glxy">
              <li class="nav-item rbc-games-tab" data-id="0">
                <Link class="nav-link active" to="/galaxy-casino/1">
                  <span class="tab-icon">🎮</span>
                  All Games
                  <span class="badge bg-warning text-dark">6</span>
                </Link>
              </li>
              <li class="nav-item rbc-games-tab" data-id="1">
                <Link class="nav-link " to="/galaxy-casino/2">
                  <span class="tab-icon">🎮</span>
                  Crash
                  <span class="badge bg-warning text-dark">1</span>
                </Link>
              </li>
              <li class="nav-item rbc-games-tab" data-id="3">
                <Link class="nav-link " to="/galaxy-casino/3">
                  <span class="tab-icon">🎮</span>
                  Card
                  <span class="badge bg-warning text-dark">5</span>
                </Link>
              </li>{" "}
            </ul>

            <ul class="nav nav-tabs desktop-tab nav-tabs-glxy ">
              <li class="nav-item rbc-games-tab" data-id="0">
                <Link class="nav-link active" to="/galaxy-casino/1">
                  <span class="tab-icon">🎮</span>
                  All Games
                  <span class="badge bg-warning text-dark">6</span>
                </Link>
              </li>
              <li class="nav-item rbc-games-tab" data-id="1">
                <Link class="nav-link " to="/galaxy-casino/2">
                  <span class="tab-icon">🎮</span>
                  Crash
                  <span class="badge bg-warning text-dark">1</span>
                </Link>
              </li>
              <li class="nav-item rbc-games-tab" data-id="3">
                <Link class="nav-link " to="/galaxy-casino/3">
                  <span class="tab-icon">🎮</span>
                  Card
                  <span class="badge bg-warning text-dark">5</span>
                </Link>
              </li>{" "}
            </ul>
          </div>

          <div id="rbc-game-view">
            <div class="container-fluid RBC-Jetx-MainContainer">
              <div class="RBC-Jetx-LeftPanel" id="lastresults">
                {Object.keys(resultList).map((key) => (
                  <div
                    className="resultbox"
                    style={{
                      backgroundImage:
                        resultList[key] === 1
                          ? "linear-gradient(rgb(161, 20, 37), rgb(64, 11, 17)), linear-gradient(rgb(255, 255, 255) 0%, rgba(255, 255, 255, 0))"
                          : "linear-gradient(rgb(16, 100, 169), rgb(3, 36, 64)), linear-gradient(rgb(255, 255, 255) 0%, rgba(255, 255, 255, 0))"
                    }}
                  >
                    {resultList[key] === 1 ? "7D" : "7U"}
                  </div>
                ))}
                {/*{Object.keys(resultList).map((key) => (
                  <div
                    class="resultbox"
                    style={{
                      backgroundImage: getBgColor(resultList[key])
                    }}
                  >
                    {getDisplayText(resultList[key])}
                  </div>
                ))}*/}
              </div>

              <div class="RBC-Jetx-CenterPanel">
                <div
                  class="RBC-Jetx-GameScreen B-height scroll-containeraviator-galaxy"
                  style={{
                    background:
                      "linear-gradient(rgb(52, 5, 11), rgb(2, 17, 30))"
                  }}
                >
                  <div class="RBC-7UD-table">
                    <div>
                      <div class="RBC-7UD-box" id="gameCards1">
                        <img
                          id="img3"
                          src={`../assets/galaxy/img/cards3/${card1}.svg`}
                          alt="Card Image"
                        />
                      </div>
                      <div class="RBC-7UD-label RBC-7UD-orange">A To 6</div>
                    </div>
                    <div>
                      <div
                        class="RBC-7UD-box RBC-7UD-middle-box"
                        id="gameCards3"
                      >
                        <img
                          id="img3"
                          src={`../assets/galaxy/img/cards3/${card3}.svg`}
                          alt="Card Image"
                        />
                      </div>
                      <div class="RBC-7UD-label">7</div>
                    </div>
                    <div>
                      <div class="RBC-7UD-box" id="gameCards2">
                        <img
                          id="img3"
                          src={`../assets/galaxy/img/cards3/${card2}.svg`}
                          alt="Card Image"
                        />
                      </div>
                      <div class="RBC-7UD-label RBC-7UD-orange">8 to K</div>
                    </div>
                  </div>

                  <div
                    className={`overlayaviatorx-galaxy
                     ${suspend1 == 1 ? "hides" : ""}`}
                  >
                    <div class="overlay-contentx">
                      <span class="overlay-textaviatorx">
                        <b style={{ color: "white", fontSize: "18px" }}>
                          Place Bets in <span id="game-time">{timeLeft}</span>
                        </b>
                      </span>
                    </div>
                  </div>

                  <div class="waveStrength-3">
                    <div class="wv4 wave">
                      <div class="wv3 wave">
                        <div class="wv2 wave">
                          <div class="wv1 wave"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="round-id-container">
                    7UpDown &nbsp;<span id="round-id">{roundId}</span>
                    <span class="info-icon openPopUpDetail">ⓘ</span>
                  </div>
                  <div class="Connectedclients-glxy mt-1">
                    <span class="user-icon"></span>{" "}
                    <b>
                      <span id="UsersCount" class="number">
                        23
                      </span>
                    </b>
                  </div>
                </div>
                <div class="relative">
                  <div class="RBC-2-chip-odds-view-ctn-glaxy desktop-tab">
                    <div class="RBC-2-chip-odds-view-layer">
                      <div class="t-l-ctn col-3">
                        <div class="total-bets">
                          <span class="text" style={{ color: "#b97f2b" }}>
                            TOTAL BET
                          </span>{" "}
                          <span
                            class="t-count total-bets2"
                            style={{ color: "#b97f2b" }}
                          >
                            0
                          </span>
                        </div>
                      </div>
                      <div class="chipDeck col-6">
                        <div class="chip-ctn">
                          <div id="fadeIn" class="show-stakes">
                            <div class="chips-layer">
                              <div
                                onClick={() => setChipActive(100)}
                                className={
                                  chipActive === 100
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt=""
                                  class="chipimg"
                                />{" "}
                                <span class="cdChipSpan" dataval="100">
                                  100
                                </span>
                              </div>

                              <div
                                onClick={() => setChipActive(500)}
                                className={
                                  chipActive === 500
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip2.svg"
                                  alt=""
                                  class="chipimg"
                                />{" "}
                                <span class="cdChipSpan" dataval="500">
                                  500
                                </span>
                              </div>

                              <div
                                onClick={() => setChipActive(1000)}
                                className={
                                  chipActive === 1000
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip3.svg"
                                  alt=""
                                  class="chipimg"
                                />{" "}
                                <span class="cdChipSpan" dataval="1000">
                                  1k
                                </span>
                              </div>
                              <div
                                onClick={() => setChipActive(2000)}
                                className={
                                  chipActive === 2000
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip4.svg"
                                  alt=""
                                  class="chipimg"
                                />{" "}
                                <span class="cdChipSpan" dataval="2000">
                                  2k
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="ure-btn col-3">
                        <div
                          class="undo-ctn undoFunc"
                          style={{ marginLeft: "30px" }}
                          onClick={() => undo()}
                        >
                          <img
                            src="../assets/galaxy/img/undo-icon.svg"
                            alt=""
                            class="undo-icon"
                          />
                          <span>Undo</span>
                        </div>

                        <div
                          class="reset-ctn resetFunc"
                          onClick={() => resetGame()}
                        >
                          <img
                            src="../assets/galaxy/img/reset-icon.svg"
                            alt=""
                            class="reset-icon"
                          />
                          <span>Reset</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="RBC-2-chip-odds-view-ctn mobile-View">
                    <div class="RBC-2-chip-odds-view-layer">
                      <div
                        class="t-l-ctn-glaxy col-12"
                        style={{ marginTop: "10px" }}
                      >
                        <div class="total-bets">
                          <span
                            class="text"
                            style={{ color: "#b97f2b", fontSize: "12px" }}
                          >
                            TOTAL BET
                          </span>{" "}
                          <span
                            class="t-count total-bets2"
                            style={{ color: "#b97f2b", fontSize: "12px" }}
                          >
                            0
                          </span>
                        </div>
                        <div
                          class="undo-ctn undoFunc"
                          style={{ marginLeft: "30px" }}
                          onClick={() => undo()}
                        >
                          <img
                            src="../assets/galaxy/img/undo-icon.svg"
                            alt=""
                            class="undo-icon"
                          />
                          <span>Undo</span>
                        </div>

                        <div
                          class="reset-ctn resetFunc"
                          onClick={() => resetGame()}
                        >
                          <img
                            src="../assets/galaxy/img/reset-icon.svg"
                            alt=""
                            class="reset-icon"
                          />
                          <span>Reset</span>
                        </div>
                      </div>
                    </div>
                    <div class="chipDeck col-12" style={{ marginTop: "10px" }}>
                      <div class="chip-ctn">
                        <div id="fadeIn" class="show-stakes">
                          <div class="chips-layer">
                            <div
                              onClick={() => setChipActive(100)}
                              className={
                                chipActive === 100
                                  ? "cdChip active"
                                  : "cdChip noActive"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/chip1.svg"
                                alt=""
                                class="chipimg"
                              />{" "}
                              <span class="cdChipSpan" dataval="100">
                                100
                              </span>
                            </div>

                            <div
                              onClick={() => setChipActive(500)}
                              className={
                                chipActive === 500
                                  ? "cdChip active"
                                  : "cdChip noActive"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/chip2.svg"
                                alt=""
                                class="chipimg"
                              />{" "}
                              <span class="cdChipSpan" dataval="500">
                                500
                              </span>
                            </div>

                            <div
                              onClick={() => setChipActive(1000)}
                              className={
                                chipActive === 1000
                                  ? "cdChip active"
                                  : "cdChip noActive"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/chip3.svg"
                                alt=""
                                class="chipimg"
                              />{" "}
                              <span class="cdChipSpan" dataval="1000">
                                1K
                              </span>
                            </div>

                            <div
                              onClick={() => setChipActive(2000)}
                              className={
                                chipActive === 2000
                                  ? "cdChip active"
                                  : "cdChip noActive"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/chip4.svg"
                                alt=""
                                class="chipimg"
                              />{" "}
                              <span class="cdChipSpan" dataval="2000">
                                2k
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="odds-view">
                    <div class="chip-odds-view-ctn ">
                      <div class="layout-three-odds-ctn">
                        <div class="lt-o-l">
                          <div class="lt-odds-ctn">
                            <div class="s-down-ctn">
                              <div
                                class="s-o-img span1details"
                                data-teamname="low card"
                                data-bettype="b"
                                onClick={() =>
                                  initializeBet(
                                    "m",
                                    "low card",
                                    "b",
                                    sevenDownOdd
                                  )
                                }
                              >
                                <span>7Down</span>
                                <img
                                  src="../assets/galaxy/img/7updownpic.svg"
                                  alt=""
                                />
                                <span class="odd">{sevenDownOdd}</span>
                              </div>

                              <div
                                className={
                                  sevenDown > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">{sevenDown}</span>
                              </div>

                              <span
                                className={
                                  sevenDownWin
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div class="s-s-ctn">
                              <div
                                class="s-o-img span1details"
                                data-teamname="tie card"
                                data-bettype="b"
                                onClick={() =>
                                  initializeBet("m", "tie card", "b", sevenOdd)
                                }
                              >
                                <span>Seven</span>
                                <img
                                  src="../assets/galaxy/img/7up7pic.svg"
                                  alt=""
                                />
                                <span class="odd">{sevenOdd}</span>
                              </div>

                              <div
                                className={
                                  seven > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                                id="b3Chips"
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">{seven}</span>
                              </div>
                              <span
                                className={
                                  sevenWin
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon-glaxy"
                                />
                              </span>
                            </div>

                            <div class="s-up-ctn">
                              <div
                                class="s-o-img span1details"
                                data-teamname="high card"
                                data-bettype="b"
                                onClick={() =>
                                  initializeBet(
                                    "m",
                                    "high card",
                                    "b",
                                    sevenUpOdd
                                  )
                                }
                              >
                                <span>7Up</span>
                                <img
                                  src="../assets/galaxy/img/7upuppic.svg"
                                  alt=""
                                />
                                <span class="odd">{sevenUpOdd}</span>
                              </div>

                              <div
                                className={
                                  sevenUp > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                                id="b2Chips"
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">{sevenUp}</span>
                              </div>
                              <span
                                className={
                                  sevenUpWin
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="d-t-suit-ctn">
                          <div class="d-oe-c">
                            <div class="oe-ctn">
                              <div class="m-name">Odd-Even</div>
                              <div class="e-o-odds">
                                <div
                                  class="even-odd span1details"
                                  data-teamname="even"
                                  data-bettype="b"
                                  onClick={() =>
                                    initializeBet("f", "even", "b", evenOdd)
                                  }
                                >
                                  <span>Even</span>
                                  <span class="odd">{evenOdd}</span>
                                  <div
                                    className={
                                      evenAmount > 0
                                        ? "Rou-image-container-glaxy"
                                        : "Rou-image-container-glaxy hide"
                                    }
                                  >
                                    <img
                                      src="../assets/galaxy/img/chip1.svg"
                                      alt="Winner Icon"
                                      class="rol-winner-icon-glaxy"
                                    />
                                    <span class="Rou-image-text">
                                      {evenAmount}
                                    </span>
                                  </div>
                                  <span
                                    className={
                                      evenWin
                                        ? "zero-value-glaxy"
                                        : "zero-value-glaxy hides"
                                    }
                                  >
                                    <img
                                      src="../assets/galaxy/img/roul-winner.webp"
                                      alt="Zero Icon"
                                      class="zero-icon"
                                    />
                                  </span>
                                </div>
                                <div
                                  class="even-odd span1details"
                                  data-teamname="odd"
                                  data-bettype="b"
                                  onClick={() =>
                                    initializeBet("f", "odd", "b", oddOdd)
                                  }
                                >
                                  <span>Odd</span>
                                  <span class="odd">{oddOdd}</span>
                                  <div
                                    className={
                                      oddAmount > 0
                                        ? "Rou-image-container-glaxy"
                                        : "Rou-image-container-glaxy hide"
                                    }
                                  >
                                    <img
                                      src="../assets/galaxy/img/chip1.svg"
                                      alt="Winner Icon"
                                      class="rol-winner-icon-glaxy"
                                    />
                                    <span class="Rou-image-text">
                                      {oddAmount}
                                    </span>
                                  </div>
                                  <span
                                    className={
                                      oddWin
                                        ? "zero-value-glaxy"
                                        : "zero-value-glaxy hides"
                                    }
                                  >
                                    <img
                                      src="../assets/galaxy/img/roul-winner.webp"
                                      alt="Zero Icon"
                                      class="zero-icon"
                                    />
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="color-ctn">
                              <div class="m-name">Color</div>
                              <div class="e-o-odds">
                                <div
                                  class="even-odd span1details"
                                  data-teamname="red"
                                  data-bettype="b"
                                  onClick={() =>
                                    initializeBet("f", "red", "b", redOdd)
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/suits-red.svg"
                                    alt=""
                                  />
                                  <span class="odd">{redOdd}</span>
                                  <div
                                    className={
                                      redAmount > 0
                                        ? "Rou-image-container-glaxy"
                                        : "Rou-image-container-glaxy hide"
                                    }
                                  >
                                    <img
                                      src="../assets/galaxy/img/chip1.svg"
                                      alt="Winner Icon"
                                      class="rol-winner-icon-glaxy"
                                    />
                                    <span class="Rou-image-text">
                                      {redAmount}
                                    </span>
                                  </div>
                                  <span
                                    className={
                                      redWin
                                        ? "zero-value-glaxy"
                                        : "zero-value-glaxy hides"
                                    }
                                  >
                                    <img
                                      src="../assets/galaxy/img/roul-winner.webp"
                                      alt="Zero Icon"
                                      class="zero-icon"
                                    />
                                  </span>
                                </div>
                                <div
                                  class="even-odd span1details"
                                  data-teamname="black"
                                  data-bettype="b"
                                  onClick={() =>
                                    initializeBet("f", "black", "b", blackOdd)
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/suits-black.svg"
                                    alt=""
                                  />
                                  <span class="odd">{blackOdd}</span>
                                  <div
                                    className={
                                      blackAmount > 0
                                        ? "Rou-image-container-glaxy"
                                        : "Rou-image-container-glaxy hide"
                                    }
                                  >
                                    <img
                                      src="../assets/galaxy/img/chip1.svg"
                                      alt="Winner Icon"
                                      class="rol-winner-icon-glaxy"
                                    />
                                    <span class="Rou-image-text">
                                      {blackAmount}
                                    </span>
                                  </div>
                                  <span
                                    className={
                                      blackWin
                                        ? "zero-value-glaxy"
                                        : "zero-value-glaxy hides"
                                    }
                                  >
                                    <img
                                      src="../assets/galaxy/img/roul-winner.webp"
                                      alt="Zero Icon"
                                      class="zero-icon"
                                    />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="vector"></div>
                          <div class="d-suit-ctn">
                            <div class="m-name">Suit {suitOdd}</div>
                            <div class="d-r-odds">
                              <div
                                class="ds-ctn span1details"
                                data-teamname="spade"
                                data-bettype="b"
                                onClick={() =>
                                  initializeBet("f", "spade", "b", suitOdd)
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/spade.svg"
                                  alt=""
                                  class="b-img"
                                />
                                <div
                                  className={
                                    hhAmount > 0
                                      ? "Rou-image-container-glaxy"
                                      : "Rou-image-container-glaxy hide"
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/chip1.svg"
                                    alt="Winner Icon"
                                    class="rol-winner-icon-glaxy"
                                  />
                                  <span class="Rou-image-text">{hhAmount}</span>
                                  <span class="odd hides">{suitOdd}</span>
                                </div>
                                <span
                                  className={
                                    spadeWin
                                      ? "zero-value-glaxy"
                                      : "zero-value-glaxy hides"
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/roul-winner.webp"
                                    alt="Zero Icon"
                                    class="zero-icon"
                                  />
                                </span>
                              </div>

                              <div
                                class="ds-ctn span1details"
                                data-teamname="heart"
                                data-bettype="b"
                                onClick={() =>
                                  initializeBet("f", "heart", "b", suitOdd)
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/heart.svg"
                                  alt=""
                                  class="b-img"
                                />
                                <div
                                  className={
                                    ddAmount > 0
                                      ? "Rou-image-container-glaxy"
                                      : "Rou-image-container-glaxy hide"
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/chip1.svg"
                                    alt="Winner Icon"
                                    class="rol-winner-icon-glaxy"
                                  />
                                  <span class="Rou-image-text">{ddAmount}</span>
                                  <span class="odd hides">{suitOdd}</span>
                                </div>
                                <span
                                  className={
                                    heartWin
                                      ? "zero-value-glaxy"
                                      : "zero-value-glaxy hides"
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/roul-winner.webp"
                                    alt="Zero Icon"
                                    class="zero-icon"
                                  />
                                </span>
                              </div>

                              <div
                                class="ds-ctn span1details"
                                data-bettype="b"
                                onClick={() =>
                                  initializeBet("f", "club", "b", suitOdd)
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/club.svg"
                                  alt=""
                                  class="b-img"
                                />
                                <div
                                  className={
                                    ccAmount > 0
                                      ? "Rou-image-container-glaxy"
                                      : "Rou-image-container-glaxy hide"
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/chip1.svg"
                                    alt="Winner Icon"
                                    class="rol-winner-icon-glaxy"
                                  />
                                  <span class="Rou-image-text">{ccAmount}</span>
                                  <span class="odd hides">{suitOdd}</span>
                                </div>
                                <span
                                  className={
                                    clubWin
                                      ? "zero-value-glaxy"
                                      : "zero-value-glaxy hides"
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/roul-winner.webp"
                                    alt="Zero Icon"
                                    class="zero-icon"
                                  />
                                </span>
                              </div>
                              <div
                                class="ds-ctn span1details"
                                data-teamname="diamond"
                                data-bettype="b"
                                onClick={() =>
                                  initializeBet("f", "diamond", "b", suitOdd)
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/diamond.svg"
                                  alt=""
                                  class="b-img"
                                />
                                <div
                                  className={
                                    ssAmount > 0
                                      ? "Rou-image-container-glaxy"
                                      : "Rou-image-container-glaxy hide"
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/chip1.svg"
                                    alt="Winner Icon"
                                    class="rol-winner-icon-glaxy"
                                  />
                                  <span class="Rou-image-text">{ssAmount}</span>
                                  <span class="odd hides">{suitOdd}</span>
                                </div>
                                <span
                                  className={
                                    diamondWin
                                      ? "zero-value-glaxy"
                                      : "zero-value-glaxy hides"
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/roul-winner.webp"
                                    alt="Zero Icon"
                                    class="zero-icon"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="m-name mt-2">3 card</div>
                        <div class="Three-card-ctn">
                          <div
                            class="e-runner  span1details"
                            data-teamname="a23"
                            data-bettype="b"
                            onClick={() =>
                              initializeBet("f", "a23", "b", card3Odd)
                            }
                          >
                            <div class="e-runner-name odd">{card3Odd}</div>
                            <div class="e-cards ">
                              <img
                                src="../assets/galaxy/img/A.svg"
                                alt=""
                                class="card-img"
                              />{" "}
                              <img
                                src="../assets/galaxy/img/2.svg"
                                alt=""
                                class="card-img"
                              />{" "}
                              <img
                                src="../assets/galaxy/img/3.svg"
                                alt=""
                                class="card-img"
                              />
                            </div>

                            <div
                              className={
                                card1SetAmount > 0
                                  ? "Rou-image-container-glaxy"
                                  : "Rou-image-container-glaxy hide"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/chip1.svg"
                                alt="Winner Icon"
                                class="rol-winner-icon-glaxy"
                              />
                              <span class="Rou-image-text">
                                {card1SetAmount}
                              </span>
                            </div>
                            <span
                              className={
                                a23Win
                                  ? "zero-value-glaxy"
                                  : "zero-value-glaxy hides"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/roul-winner.webp"
                                alt="Zero Icon"
                                class="zero-icon"
                              />
                            </span>
                          </div>

                          <div
                            class="e-runner span1details"
                            data-bettype="b"
                            onClick={() =>
                              initializeBet("f", "456", "b", card3Odd)
                            }
                          >
                            <div class="e-runner-name odd">{card3Odd}</div>
                            <div class="e-cards ">
                              <img
                                src="../assets/galaxy/img/4.svg"
                                alt=""
                                class="card-img"
                              />{" "}
                              <img
                                src="../assets/galaxy/img/5.svg"
                                alt=""
                                class="card-img"
                              />{" "}
                              <img
                                src="../assets/galaxy/img/6.svg"
                                alt=""
                                class="card-img"
                              />
                            </div>

                            <div
                              className={
                                card2SetAmount > 0
                                  ? "Rou-image-container-glaxy"
                                  : "Rou-image-container-glaxy hide"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/chip1.svg"
                                alt="Winner Icon"
                                class="rol-winner-icon-glaxy"
                              />
                              <span class="Rou-image-text">
                                {card2SetAmount}
                              </span>
                            </div>

                            <span
                              className={
                                card456Win
                                  ? "zero-value-glaxy"
                                  : "zero-value-glaxy hides"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/roul-winner.webp"
                                alt="Zero Icon"
                                class="zero-icon"
                              />
                            </span>
                          </div>

                          <div
                            class="e-runner  span1details"
                            data-bettype="b"
                            onClick={() =>
                              initializeBet("f", "8910", "b", card3Odd)
                            }
                          >
                            <div class="e-runner-name odd">{card3Odd}</div>
                            <div class="e-cards ">
                              <img
                                src="../assets/galaxy/img/8.svg"
                                alt=""
                                class="card-img"
                              />{" "}
                              <img
                                src="../assets/galaxy/img/9.svg"
                                alt=""
                                class="card-img"
                              />{" "}
                              <img
                                src="../assets/galaxy/img/10.svg"
                                alt=""
                                class="card-img"
                              />
                            </div>

                            <div
                              className={
                                card3SetAmount > 0
                                  ? "Rou-image-container-glaxy"
                                  : "Rou-image-container-glaxy hide"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/chip1.svg"
                                alt="Winner Icon"
                                class="rol-winner-icon-glaxy"
                              />
                              <span class="Rou-image-text">
                                {card3SetAmount}
                              </span>
                            </div>
                            <span
                              className={
                                card8910Win
                                  ? "zero-value-glaxy"
                                  : "zero-value-glaxy hides"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/roul-winner.webp"
                                alt="Zero Icon"
                                class="zero-icon"
                              />
                            </span>
                          </div>

                          <div
                            class="e-runner  span1details"
                            data-teamname="jqk"
                            data-bettype="b"
                            onClick={() =>
                              initializeBet("f", "jqk", "b", card3Odd)
                            }
                          >
                            <div class="e-runner-name odd">{card3Odd}</div>
                            <div class="e-cards ">
                              <img
                                src="../assets/galaxy/img/j.svg"
                                alt=""
                                class="card-img"
                              />{" "}
                              <img
                                src="../assets/galaxy/img/q.svg"
                                alt=""
                                class="card-img"
                              />{" "}
                              <img
                                src="../assets/galaxy/img/k.svg"
                                alt=""
                                class="card-img"
                              />
                            </div>

                            <div
                              className={
                                card4SetAmount > 0
                                  ? "Rou-image-container-glaxy"
                                  : "Rou-image-container-glaxy hide"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/chip1.svg"
                                alt="Winner Icon"
                                class="rol-winner-icon-glaxy"
                              />
                              <span class="Rou-image-text">
                                {card4SetAmount}
                              </span>
                            </div>
                            <span
                              className={
                                jqkWin
                                  ? "zero-value-glaxy"
                                  : "zero-value-glaxy hides"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/roul-winner.webp"
                                alt="Zero Icon"
                                class="zero-icon"
                              />
                            </span>
                          </div>
                        </div>

                        <div class="m-name mt-2">Card</div>
                        <div class="single-cards-ctn">
                          <div class="e-runner-name">{singleCardOdd}</div>
                          <div class="single-m-ctn">
                            <div
                              class="c-runner  span1details"
                              data-teamname="card 1"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet("f", "card 1", "b", singleCardOdd)
                              }
                            >
                              <img
                                src="../assets/galaxy/img/A.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card1Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card1Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card1Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div
                              class="c-runner  span1details"
                              data-teamname="card 2"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet("f", "card 2", "b", singleCardOdd)
                              }
                            >
                              <img
                                src="../assets/galaxy/img/2.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card2Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card2Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card2Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div
                              class="c-runner  span1details"
                              data-teamname="card 3"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet("f", "card 3", "b", singleCardOdd)
                              }
                            >
                              <img
                                src="../assets/galaxy/img/3.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card3Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card3Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card3Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div
                              class="c-runner  span1details"
                              data-teamname="card 4"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet("f", "card 4", "b", singleCardOdd)
                              }
                            >
                              <img
                                src="../assets/galaxy/img/4.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card4Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card4Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card4Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div
                              class="c-runner  span1details"
                              data-teamname="card 5"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet("f", "card 5", "b", singleCardOdd)
                              }
                            >
                              <img
                                src="../assets/galaxy/img/5.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card5Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card5Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card5Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div
                              class="c-runner  span1details"
                              data-teamname="card 6"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet("f", "card 6", "b", singleCardOdd)
                              }
                            >
                              <img
                                src="../assets/galaxy/img/6.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card6Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card6Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card6Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div
                              class="c-runner  span1details"
                              data-teamname="card 7"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet("f", "card 7", "b", singleCardOdd)
                              }
                            >
                              <img
                                src="../assets/galaxy/img/7.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card7Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card7Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card7Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div
                              class="c-runner  span1details"
                              data-teamname="card 8"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet("f", "card 8", "b", singleCardOdd)
                              }
                            >
                              <img
                                src="../assets/galaxy/img/8.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card8Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card8Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card8Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div
                              class="c-runner  span1details"
                              data-teamname="card 9"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet("f", "card 9", "b", singleCardOdd)
                              }
                            >
                              <img
                                src="../assets/galaxy/img/9.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card9Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card9Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card9Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div
                              class="c-runner  span1details"
                              data-teamname="card 10"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet(
                                  "f",
                                  "card 10",
                                  "b",
                                  singleCardOdd
                                )
                              }
                            >
                              <img
                                src="../assets/galaxy/img/10.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card10Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card10Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card10Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div
                              class="c-runner  span1details"
                              data-teamname="card 11"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet(
                                  "f",
                                  "card 11",
                                  "b",
                                  singleCardOdd
                                )
                              }
                            >
                              <img
                                src="../assets/galaxy/img/j.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card11Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card11Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card11Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div
                              class="c-runner  span1details"
                              data-teamname="card 12"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet(
                                  "f",
                                  "card 12",
                                  "b",
                                  singleCardOdd
                                )
                              }
                            >
                              <img
                                src="../assets/galaxy/img/q.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card12Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card12Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card12Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>

                            <div
                              class="c-runner  span1details"
                              data-teamname="card 13"
                              data-bettype="b"
                              onClick={() =>
                                initializeBet(
                                  "f",
                                  "card 13",
                                  "b",
                                  singleCardOdd
                                )
                              }
                            >
                              <img
                                src="../assets/galaxy/img/k.svg"
                                alt=""
                                class="card-img"
                              />
                              <div
                                className={
                                  card13Amount > 0
                                    ? "Rou-image-container-glaxy"
                                    : "Rou-image-container-glaxy hide"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt="Winner Icon"
                                  class="rol-winner-icon-glaxy"
                                />
                                <span class="Rou-image-text">
                                  {card13Amount}
                                </span>
                                <span class="odd hides">{singleCardOdd}</span>
                              </div>
                              <span
                                className={
                                  card13Win
                                    ? "zero-value-glaxy"
                                    : "zero-value-glaxy hides"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/roul-winner.webp"
                                  alt="Zero Icon"
                                  class="zero-icon"
                                />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div
                          aria-hidden="true"
                          class="MuiBackdrop-root css-rljl56"
                          style={{
                            opacity: "1",
                            transition:
                              "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)"
                          }}
                        >
                          <svg
                            focusable="false"
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            data-testid="LockIcon"
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium lock-icon css-vubbuv"
                          >
                            <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      suspend1 == 0
                        ? "overlayRoulettelock-galaxy hide"
                        : "overlayRoulettelock-galaxy"
                    }
                  >
                    <div style={{ textAlign: "center" }}>
                      <svg
                        focusable="false"
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        data-testid="LockIcon"
                        class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium lock-icon css-vubbuv"
                        style={{ width: "70px", filter: "invert(0)" }}
                      >
                        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path>
                      </svg>{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div class="RBC-Jetx-RightPanel">
                <table class="RBC-Jetx-Table">
                  <thead>
                    <tr>
                      <th>Runner</th>
                      <th>Price</th>
                      <th>Size</th>
                    </tr>
                  </thead>
                  <tbody id="refreshhistory">
                    {betList &&
                      betList !== null &&
                      betList !== undefined &&
                      betList !== "" &&
                      betList.map((bet) => (
                        <tr>
                          <th style={{ textTransform: "uppercase" }}>
                            {bet.rnrname}
                          </th>
                          <th>{bet.rate}</th>
                          <th>{bet.lib}</th>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <style>
          {` 
                body {
                    background: linear-gradient(180deg, #0D0D0D, #18122B);
                    color: #EAEAEA;
                    margin: 0;
                    padding: 0;
                    background-attachment: fixed;
                    touch-action: manipulation;
                }
                .overlay-textaviatorx {
                  margin-top: 10px;
                  font-size: 2.5em;
                  color: #FFD700;
              }`}
        </style>
      </div>
      <style>
        {`
          .zero-icon{
            width: 36px;
            height: 36px;
          }
             `}
      </style>
    </GalaxyLayout>
  );
}
